import Cookies from "js-cookie";
import { all, put, takeLatest } from "redux-saga/effects";

import { loginUser, logout } from "../reducers/auth";
import { setMeData } from "../reducers/user";

function* setData(action: any) {
  return action;
}

function* login(action: any) {
  return action;
}

function* logOutUser(action: any) {
  const exclude = localStorage.getItem("isHalfPriceTraffic");
  localStorage.clear();
  if (exclude) {
    localStorage.setItem("isHalfPriceTraffic", exclude);
  }
  yield Cookies.remove("access_token");
  yield Cookies.remove("refresh_token");
  yield Cookies.remove("video_token");
}

export default function* root() {
  yield all([takeLatest(setMeData.type, setData)]);
  yield all([takeLatest(loginUser.type, login)]);
  yield all([takeLatest(logout.type, logOutUser)]);
}
